import React, { useState } from 'react';
import DashHeader from '../components/DashHeader'
import DashSide from '../components/DashSide';


const Sermon = () => {
  const [sermonTitle, setSermonTitle] = useState('');
  const [preacherName, setPreacherName] = useState('');
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    // Perform form submission logic here
    // You can send the form data to a server or handle it in any way you want

    // Clear form fields after submission
    setSermonTitle('');
    setPreacherName('');
    setDate('');
    setTime('');
  };

    return (
      <div className="w-screen  justify-center items-center h-screen bg-gray-100">        
        <div className=''>
          <DashHeader/>
        </div>  
        <div className='flex flex-1'>
          <DashSide/>
        <div>
        <div className="m-[120px] w-[600px]">
          <h1 className="text-2xl font-bold mb-4">Register Church Sermon</h1>
          
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="sermonTitle" className="block font-medium text-gray-700">
                Sermon Title:
              </label>
              <input
                type="text"
                id="sermonTitle"
                value={sermonTitle}
                onChange={(e) => setSermonTitle(e.target.value)}
                className="form-input mt-1 block w-full"
                required
              />
            </div>
            
            <div>
              <label htmlFor="preacherName" className="block font-medium text-gray-700">
                Preacher Name:
              </label>
              <input
                type="text"
                id="preacherName"
                value={preacherName}
                onChange={(e) => setPreacherName(e.target.value)}
                className="form-input mt-1 block w-full"
                required
              />
            </div>
            
            <div>
              <label htmlFor="date" className="block font-medium text-gray-700">
                Date:
              </label>
              <input
                type="date"
                id="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                className="form-input mt-1 block w-full"
                required
              />
            </div>
            
            <div>
              <label htmlFor="time" className="block font-medium text-gray-700">
                Time:
              </label>
              <input
                type="time"
                id="time"
                value={time}
                onChange={(e) => setTime(e.target.value)}
                className="form-input mt-1 block w-full"
                required
              />
            </div>
            
            <button
              type="submit"
              className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md"
            >
              Register Sermon
            </button>
          </form>
        </div>
      </div>
    </div>     
  </div>
    )
}
export default Sermon;